import { makeAutoObservable } from 'mobx';
import { VisibleSectionType } from '@features/productPreview/const';
export default class ProductPreviewPageState {
  actualVisibleSection: VisibleSectionType | null = null;
  deliveryOpen = false;
  isVideoCollectionRunning = false;
  activeVideo: number | null = null;
  isOldConfigurator = false;
  constructor() {
    makeAutoObservable(this);
  }
  public setVideoCollectionActive = (value: boolean) => {
    this.isVideoCollectionRunning = value;
    this.activeVideo = null;
  };
  public setActiveVideo = (id: number | null) => {
    this.activeVideo = id;
    this.isVideoCollectionRunning = false;
  };
  public setNextActiveVideo = () => {
    if (this.activeVideo === null) {
      this.activeVideo = 0;
    } else {
      this.activeVideo = (this.activeVideo + 1) % 3;
    }
  };
  public setEntry(entry: IntersectionObserverEntry | undefined) {
    if (entry?.isIntersecting) {
      this.setActiveVideo(0);
    }
  }
  public setActualVisibleSection = (section: VisibleSectionType | null) => {
    if (section !== this.actualVisibleSection) {
      this.actualVisibleSection = section;
    }
  };
  public setDeliveryOpen = (option: boolean) => {
    this.deliveryOpen = option;
  };
  public setIsOldConfigurator = (isOld: boolean) => {
    this.isOldConfigurator = isOld;
  };
}